import { PartialDeep } from 'type-fest';

import formatPrice from 'src/utils/currency-code-to-symbol';
import { Badge } from '@/components/ui/badge';
import { Card } from '@/components/ui/card';
import { cn } from 'src/lib/utils';

import type { IPlan } from 'src/graphql/schema';

type Props = {
  plan: PartialDeep<IPlan>;
  className?: string;
  features?: React.ReactNode;
  icon: React.ElementType;
  badge: {
    text: string;
    bgColor: string;
  };
};

export default function BillingPlan({ plan, className, features, icon, badge }: Props) {
  const Icon = icon;

  return (
    <Card className={cn('p-6 space-y-6 bg-accent', className)}>
      <div className="relative flex-col sm:flex-row flex justify-between items-start sm:items-center gap-2">
        <Icon className="size-5 sm:size-7 absolute left-0 top-0" />
        <h6 className="pl-7 sm:pl-9 sm:min-h-7 text-sm sm:text-lg font-semibold text-foreground">
          {plan.externalName}
        </h6>
        <Badge className={cn('whitespace-nowrap', badge.bgColor)}>{badge.text}</Badge>
      </div>

      <div className="flex">
        <div className="flex flex-col gap-2 flex-1">
          <div className="text-sm text-muted-foreground">
            Price/
            <span className="capitalize">{plan.periodUnit}</span>
          </div>
          <strong className="text-base font-semibold leading-4">{formatPrice(plan.currencyCode, plan.price)}</strong>
        </div>
      </div>

      {features && features}
    </Card>
  );
}
